import { Select } from 'antd'
import { useCostCodes } from '../../../../../domain/costCodes/costCodeQueries'

type Props = {
  costCodeId: number | null | undefined
  onChange: (costCodeId: number) => void
}

const CostCodeSelector = ({ costCodeId, onChange }: Props) => {
  const costCodesQuery = useCostCodes()
  const options = (costCodesQuery.data ?? []).map(costCode => ({ value: costCode.id, label: costCode.name }))

  return <Select
    value={costCodeId}
    options={options}
    popupMatchSelectWidth={false}
    onChange={onChange}
    showSearch
    optionFilterProp='label'
  />
}

export default CostCodeSelector